module.exports = __webpack_public_path__ + "img/house-lg-left.6acb021e.png";